import { attributionSchema, type Attribution } from "@car/api/catalog-config";

// Where this visit came from (UTM of the ad, the referring site, the first page), kept for the
// tab's session and sent with every consult form so the Lead carries its campaign.

const KEY = "taban-attribution";

/** Called on the first page of a visit; the first touch of the session wins */
export function captureAttribution() {
  try {
    if (sessionStorage.getItem(KEY)) return;
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const from = document.referrer ? new URL(document.referrer) : null;
    const value: Attribution = {
      utmSource: params.get("utm_source") ?? "",
      utmMedium: params.get("utm_medium") ?? "",
      utmCampaign: params.get("utm_campaign") ?? "",
      // only an outside site, without its query (it may carry the visitor's search)
      referrer: from && from.host !== url.host ? `${from.origin}${from.pathname}` : "",
      landingPage: `${url.pathname}${url.search}`,
    };
    sessionStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    // storage blocked (private mode): the form still works, only without a source
  }
}

/** What captureAttribution kept; undefined when nothing was (or could be) stored */
export function readAttribution(): Attribution | undefined {
  try {
    const saved = sessionStorage.getItem(KEY);
    if (!saved) return undefined;
    const parsed = attributionSchema.safeParse(JSON.parse(saved));
    return parsed.success ? parsed.data : undefined;
  } catch {
    return undefined;
  }
}
